<template>
  <div>
    <w-table ref="wMyTable" :columns="columns" :table-data="tableData"
             @getTableSearchSortCon="getTableSearchSortCon" :isPagination="true" :initialConditions="initialConditions"
             :table-col-check="tableColCheck"
             :page="page" @pageChange="handlePagePagination">
      <!--       折叠-->
      <!--      <div slot="foldInfo" slot-scope="{text, record, index}">-->
      <!--        <ex-fold-table-cell :scope="{text:text.split('|'), record, index}"></ex-fold-table-cell>-->
      <!--      </div>-->
      <div v-for="slot in mergeProjectSlot" :slot="slot" slot-scope="{text, record, index}" :key="slot">
          <naked-table-slot :rows="record.projectInfoList" :col-name="slot" ></naked-table-slot>
      </div>

      <!--备注-->
      <span slot="remark" slot-scope="{text,record}">
        <span v-if="text&&text.length>=20">
          {{ text.substring(0, 20) }}
          <el-tooltip :content="text">
            <span style="cursor: pointer">...</span>
          </el-tooltip>
        </span>
        <span v-if="!text||text.length<20">{{ text }}</span>
      </span>
      <!--      释放方式-->
      <div slot="dataWay" slot-scope="{record}">
        <raw-release-info  :select-detail="record" @lookSampleInfo="lookSampleInfo"></raw-release-info>
      </div>
      <div slot="filterDropdownDataWay" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
           style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 0px 15px">
          <el-radio-group v-model="selectedKeys[0]">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label="硬盘释放">硬盘释放</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label="链接释放">链接释放</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button
              type="primary"
              icon="search"
              size="small"
              style="width: 90px; margin-right: 8px"
              @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
          </a-button>
        </div>
      </div>

      <template slot="operation" slot-scope="{text,record}">
        <el-button
            v-if="record?.projectInfoList.every(item => item.releaseTypes.includes('ONLINE'))||false"
            size="mini"
            type="success"
            @click="handleRawData(record)">下载原始数据
        </el-button>
        <el-button
            v-if="record?.projectInfoList.every(item => item.releaseTypes.includes('ONLINE'))||false"
            size="mini"
            type="primary"
            @click="handleShare(record)">分享
        </el-button>
      </template>
    </w-table>
    <!--    分享管理-->
    <share-customer-manager-dialog v-if="showShareCusDialog" :select-detail="selectDetail" platform="NAKED"
                                   :show-dialog="showShareCusDialog"
                                   @submit="closeShareCusDialog"></share-customer-manager-dialog>
    <!--    修改失效时间-->
    <modify-time-dialog v-if="showModifyTimeDialog" :show-dialog.sync="showModifyTimeDialog"
                        :select-detail="selectDetail" @submit="submitModify"></modify-time-dialog>
    <!--    &lt;!&ndash;    原始数据文件下载&ndash;&gt;-->
    <l-e-down-files-dialog v-if="downRawFilesDialog" :show-dialog.sync="downRawFilesDialog"
                           :downLoadUrl="downLoadRawUrl">
    </l-e-down-files-dialog>
    <l-e-down-files-volcano-dialog v-if="downRawFilesVolcanoDialog" :show-dialog.sync="downRawFilesVolcanoDialog"
                                   :downLoadUrl="downLoadRawUrl">
    </l-e-down-files-volcano-dialog>
    <!--    快递单号-->
    <look-info-dialog v-if="courierNoDialog" :show-dialog.sync="courierNoDialog"
                      :select-detail="selectDetail" title="快递单号">
      <el-form-item slot="formInfo" slot-scope="formInfo" label="快递单号">
        <el-input v-model="formInfo.courierNo" placeholder="请输入快递单号" type="textarea" readonly
                  :autosize="{ minRows: 3,}"></el-input>
      </el-form-item>
    </look-info-dialog>
    <!--    样本信息-->
    <sample-info-dialog v-if="sampleInfoDialog"
                        :show-dialog.sync="sampleInfoDialog"
                        :select-detail="selectDetail"></sample-info-dialog>
    <picture-loading v-if="loading"></picture-loading>
  </div>
</template>

<script>
import {
  downloadReport,
  listProject, modifyExpTime, rawDataLink,
} from "@/api/naked/rawData/project";
import Info from "@/views/systems/project/rawData/Info";
import ChangeUsers from "@/components/ChangeUsers";
import EditProject from "@/components/project/rawData/EditProject";
import PictureLoading from "@/components/customerTable/PictureLoading";
import LoadingDialog from "@/components/LoadingDialog";
import {columnsData} from "@/utils/data/tableCol/nakedTableCol";
import ExFoldTableCell from "@/components/ExFoldTableCell";
import ShareCustomerManagerDialog from "@/components/ShareCustomerManagerDialog";
import ModifyTimeDialog from "@/components/ModifyTimeDialog";
import downFilesDialog from "@/components/downRawData/DownFilesDialog";
import {carIcon, goodIcon, viewDetailIcon, webIcon1} from "@/utils/iconUtils";
import LookInfoDialog from "@/components/approve/LookInfoDialog";
import {modelNameEnCh} from "@/utils/data/basicData/modelNameEnCh";
import SampleInfoDialog from "@/components/SampleInfoDialog.vue";
import RawLinkInfo from "@/components/RawDataReleaseInfo/RawLinkInfo.vue";
import RawReleaseInfo from "@/components/RawDataReleaseInfo/RawReleaseInfo.vue";
import {getRawReleaseInfoByProjectSoleKey} from "@/api/dilivery";
import RawHddInfo from "@/components/RawDataReleaseInfo/RawHddInfo.vue";
import NakedTableSlot from "@/components/project/nakedRawData/NakedTableSlot.vue";
import {tableOperationMixin} from "@/mixins/tableOperation";

export default {
  name: "NakedRawData",
  mixins: [tableOperationMixin],
  components: {
    NakedTableSlot,
    RawHddInfo,
    RawLinkInfo,
    RawReleaseInfo,
    SampleInfoDialog,
    LookInfoDialog,
    downFilesDialog,
    ModifyTimeDialog,
    ShareCustomerManagerDialog,
    EditProject,
    ChangeUsers,
    Info,
    PictureLoading,
    LoadingDialog,
    ExFoldTableCell
  },
  data() {
    return {
      tableColCheck: { isShow: true, name: 'nakeRawData_col' },
      loading: true,
      isShowAddLoading: false,
      showAddLoadingMess: '文件上传中，请耐心等待.......',
      //分页
      page: {
        pageSize: 10,
        currentNum: 1,
        total: null
      },
      tableData: [],//表格数据
      searchConditionTag: [],
      sortConditionTag: '',
      showUserDialog: false,//展示更改用户的弹框
      updateProjectUserData: {
        projectId: '',
        selectedSalers: [],
        selectedAnalyze: '',
      }, //更改用户的数据（更换分析和销售）
      openDetail: false,//查看详情弹框
      detailForm: {},
      selectDetail: '',
      showModifyTimeDialog: false,//修改时间
      showShareCusDialog: false,//分享客户管理
      downRawFilesDialog: false,//原始数据下载弹框
      downLoadRawUrl: '',//原始数据下载链接
      downRawFilesInfo: {},
      initialConditions: {},//初始搜索条件
      carIcon: carIcon,
      courierNoDialog: false,
      viewDetailIcon: viewDetailIcon,
      sampleInfoDialog: false,
      downRawFilesVolcanoDialog: false,
      goodIcon: goodIcon,
      webIcon1: webIcon1,
      mergeProjectSlot:['contractNo','projectType','sampleNum','sampleInfo','customerName','salesName','reportPath']
    }
  },
  computed: {
    columns() {
      let column = columnsData(this.searchConditionTag || {})
      // if (this.$store.getters["right/getRole"] === 'USER') {
      //   column.splice(column.length-1, 1)
      // }
      return column
    }
  },
  created() {
  },
  mounted() {
    this.getData('first')
  },
  methods: {
    getData(isSearch) {
      this.loading = true
      var param = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
        'order': ''
      }
      if (isSearch === 'search') {
        param['page.size'] = 10
        param['page.current'] = 1
      }
      let sendData = {}
      // 判断是否从总览跳转过来的
      if (isSearch === 'first' && this.$route.query.id) {
        //从审批跳转过来的
        this.initialConditions = {
          searchConditionTag: [{
            title: '项目号',
            key: 'id',
            value: this.$route.query.id
          }]
        }
        this.searchConditionTag = this.initialConditions.searchConditionTag
      }
      let length = this.searchConditionTag.length
      if (length) {
        this.searchConditionTag.forEach(item => {
          let key = item.key
          if(key === 'isHdd'){
            sendData[key] = item.value==='硬盘释放'
          }else {
            sendData[key] = item.value
          }

        })
      }
      listProject(param, sendData).then(async res => {
        if (res.code === 200) {
          // this.tableData = res.data.records
          await this.getRawInfoBy(res.data.records)
          this.loading = false
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
        }
      })
    },

    async getRawInfoBy(rows) {
      let sendData = rows.map(item => {
        return {
          projectSoleKey: item.projectSoleKey,
          isHdd: item.releaseTypes.includes('HDD')||item.isHdd,
          rawLink:  item.rawLink||''
        }
      })
      const res = await getRawReleaseInfoByProjectSoleKey(sendData)
      if (res?.code === 200) {
        this.tableData = rows.map(item => {
          return {
            ...item,
            rawInfo: {...res.data[item.projectSoleKey]||{}}
          }
        })
      }
    },

    getTableSearchSortCon(searchConditionTag, sortConditionTag) {
      this.searchConditionTag = searchConditionTag
      this.sortConditionTag = sortConditionTag
      this.getData('search')
    },
    //页码的变动
    handlePagePagination(page) {
      this.loading = true
      this.page.currentNum = page.currentNum
      if (page.pageSize) {
        this.page.pageSize = page.pageSize
      } else {
        this.page.pageSize = this.page.total
      }
      this.getData()
    },
    getModelName(model) {
      return modelNameEnCh[model]
    },

    handleModify(record) {
      this.selectDetail = record
      this.showModifyTimeDialog = true
    },
    submitModify(data) {
      modifyExpTime(data).then(res => {
        if (res.code === 200) {
          this.getData()
          this.showModifyTimeDialog = false
          this.$messageUi.success('修改成功')
        }
      }).catch(() => {
        this.showModifyTimeDialog = false
      })
    },
    // 原始数据
    handleRawData(record) {
      this.downLoadRawUrl = record.rawLink
      if(this.downLoadRawUrl){
        if (record?.isRawCloud) {
          this.downRawFilesVolcanoDialog = true
        } else {
          this.downRawFilesDialog = true
        }
      }else {
        this.$messageUi.warning('暂无原始数据链接')
      }

    },
    //分享项目
    handleShare(row) {
      this.selectDetail = {
        projectId: row.id,
        customerList: row.customerList
      }
      this.showShareCusDialog = true
    },
    //关闭分享
    closeShareCusDialog() {
      this.showShareCusDialog = false
    },
    lookCourierNo(courierNo) {
      this.selectDetail = {courierNo: courierNo}
      this.courierNoDialog = true
    },
    lookSampleInfo(row) {
      this.selectDetail = {
        projectId: row.id,
        platform: 'LUOCE',
        isNeedFilterSample: row.hasSampleNames,
        sampleNameList: row.sampleNames ? row.sampleNames : []
      }
      this.sampleInfoDialog = true
    },
    downReportFile(row, isOpenSoft) {
      downloadReport(row.id).then(res => {
        if (res?.code === 200) {
          if (isOpenSoft) {
            let url = `linenrawdownload://downloadUrl=` + res.data.replace("delivery.biozeron.com", window.location.hostname)
            //判断本地是否能启动某个命令程序
            window.protocolCheck(url,
                function () {
                  alert(`<div style="text-align: left;color: #5a5e66"><i class="el-icon-warning" style="color: #e4a13d;font-size: 16px;margin-right: 5px" ></i>检测到您未安装原始数据下载器，辛苦您下载安装后再使用软件下载数据。<br>下载地址：<a class="aLink"  href="http://58.247.16.28:63306/prod-api/client/downloader">http://58.247.16.28:63306/prod-api/client/downloader</a></div>`)
                })
          } else {
            const url = res.data.replace("delivery.biozeron.com", window.location.hostname)
            const elink = document.createElement('a')
            elink.href = url
            document.body.appendChild(elink)
            elink.click()
            document.body.removeChild(elink)
          }
        }
      })
    },
    handleCommand(command, row) {
      this.downReportFile(row, command === 'soft')
    },

  }

}
</script>

<style scoped>
/deep/ .merge_col_td .ant-table-header-column {
  display: flex;
  justify-content: center;
  padding: 10px;

}
/deep/ .merge_col_td {
  padding: 0px !important;
}
</style>
